module.exports = __webpack_public_path__ + "static/disrupt2016-7e6ed4eedd4a88b81e3342407f95969e.svg";